var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCasesInProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42 39",
    style: {
      enableBackground: "new 0 0 42 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#050E30;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.4,8.3V5.4c0-2.1-1.6-3.7-3.6-3.7h-17l-0.6-1.1c-0.2-0.4-0.6-0.6-1-0.6H3.6C1.6,0,0,1.7,0,3.7v31.5 C0,37.3,1.6,39,3.6,39h34.7c2,0,3.6-1.7,3.6-3.7V12C42,10,40.4,8.3,38.4,8.3z M34.7,4.1c0.7,0,1.2,0.6,1.2,1.2v2.9H21.7l-1.6-2.7 l-0.9-1.4H34.7z M39.6,35.3c0,0.7-0.5,1.2-1.2,1.2H3.6c-0.7,0-1.2-0.6-1.2-1.2V3.7C2.4,3,3,2.5,3.6,2.5h11.7L16,3.6l2.3,3.9l1.6,2.7 c0.2,0.4,0.6,0.6,1,0.6h17.4c0.7,0,1.2,0.6,1.2,1.2V35.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.1,36.2c0,0.7-0.6,1.3-1.3,1.3H2.2c-0.7,0-1.3-0.6-1.3-1.3V2.8c0-0.7,0.6-1.3,1.3-1.3h12.7l0.7,1.1l2.5,4.1 l1.8,2.9c0.2,0.4,0.7,0.6,1.1,0.6h18.8c0.7,0,1.3,0.6,1.3,1.3V36.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17,20.3c-0.4-0.4-1.1-0.3-1.4,0.2c-0.3,0.5-0.5,0.9-0.6,1.4c-0.2,0.6,0.3,1.1,0.9,1.1h0c0.4,0,0.8-0.3,0.9-0.6 c0.1-0.4,0.3-0.7,0.4-1.1C17.4,21,17.3,20.6,17,20.3z M15.9,24.9L15.9,24.9c-0.6,0-1.1,0.6-0.9,1.1c0.1,0.5,0.3,1,0.6,1.4 c0.3,0.5,1,0.6,1.4,0.2c0.3-0.3,0.3-0.7,0.2-1.1c-0.2-0.3-0.3-0.7-0.4-1.1C16.6,25.2,16.3,24.9,15.9,24.9z M18.5,30.4 c0.5,0.3,1,0.5,1.5,0.6c0.6,0.2,1.1-0.3,1.1-0.9v0c0-0.4-0.3-0.8-0.6-0.9c-0.4-0.1-0.7-0.3-1.1-0.4c-0.3-0.2-0.8-0.1-1.1,0.2l0,0 C17.9,29.4,18,30.2,18.5,30.4z M22.9,16.7v-0.6c0-0.8-1-1.2-1.6-0.7l-1.9,2c-0.4,0.4-0.4,1,0,1.3l2,1.9c0.6,0.6,1.6,0.2,1.6-0.7 v-1.4c2.6,0.4,4.6,2.7,4.6,5.4c0,2.5-1.7,4.6-4,5.3c-0.4,0.1-0.6,0.5-0.6,0.9v0c0,0.6,0.6,1,1.1,0.9c3.1-0.9,5.3-3.7,5.3-7 C29.3,20.3,26.5,17.2,22.9,16.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasesInProgress);
export default __webpack_public_path__ + "static/media/cases-in-progress.8f358d4d.svg";
export { ForwardRef as ReactComponent };